// extracted by mini-css-extract-plugin
export var measureBox = "_dh-0";